import React from 'react';

import styles from './TitleSectionBack.module.scss';
import { Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { ReactComponent as ArrowRIcon } from '../../../assets/svg/icons/arrow_r.svg';
import { ROUTES } from '../../../routes/constants';

/** Pagine raggiungibili dal menu laterale (match esatto). */
const SIDEBAR_MENU_PATHS = [
  ROUTES.HOME,
  ROUTES.SCHEDULER,
  ROUTES.SALON_MANAGEMENT,
  ROUTES.CLIENTS,
  ROUTES.PAYMENTS,
  ROUTES.SHOP,
  ROUTES.STATISTICS,
  `${ROUTES.SETTINGS}${ROUTES.EXPENSES}`,
  ROUTES.REVIEWS,
  ROUTES.ADVERTISING,
  ROUTES.COMMUNICATIONS,
  ROUTES.NOTIFICATION,
  ROUTES.SETTINGS,
  ROUTES.SUPPORT,
];

const normalizePath = (pathname = '') => {
  if (pathname.length > 1 && pathname.endsWith('/')) return pathname.slice(0, -1);
  return pathname;
};

const isMenuPage = (pathname) => SIDEBAR_MENU_PATHS.includes(normalizePath(pathname));

export default ({ title, description, isActiveButton = true }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const showBack = isActiveButton && !isMenuPage(pathname);

  return (
    <div className={styles.section_back_wrapper}>
      {showBack && (
        <Button onClick={() => navigate(-1)} className={styles.arrow_button}>
          <ArrowRIcon />
        </Button>
      )}
      <div className={styles.title_section}>
        <div className={styles.title}>{title}</div>
        <div className={styles.description}>{description}</div>
      </div>
    </div>
  );
};
